export default function jsUcfirst(str) {
  if (str === null) return;
  return str.charAt(0).toUpperCase() + str.slice(1);
}
